import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@node_modules/@angular/router';
import * as moment from 'moment';
import { DateTime } from 'luxon';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AccountJournalReportServiceProxy, ChartOfAccountDto, ComboboxItemDto, CommonLookupServiceProxy, DropDownLookupDto, GeneralLedgerDto, GeneralLedgerOutputDto, GetAccountJournalInput, LocationsServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppSessionService } from '@shared/common/session/app-session.service';

@Component({
  selector: 'app-general-ledger',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()],
  templateUrl: './general-ledger.component.html',
  styleUrl: './general-ledger.component.css'
})
export class GeneralLedgerComponent implements OnInit {

    loading = false;

  // Dropdown Data
  locations: DropDownLookupDto[] = [];
  accounts: ComboboxItemDto[] = [];

  // Selection Models
  selectedLocations: any[] = [];
  selectedAccounts: any[] = [];

  // Date Range
  dateRange: Date[] = [];

  // Results
  purchaseDetail: GeneralLedgerOutputDto[] = [];
  debit = 0;
  credit = 0;
  closingBalance = 0;

  constructor(
    private accountJournalReportService: AccountJournalReportServiceProxy,
    private locationService: LocationsServiceProxy,
    private appSession: AppSessionService,
    private commonLookupService: CommonLookupServiceProxy,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.initializeDateRange();
    this.loadLocations();
    this.loadAccounts();
    this.loadFromRouteParams();
  }

  initializeDateRange() {
    const today = new Date();
    this.dateRange = [today, today];
  }

  loadLocations() {
    this.commonLookupService.getAllLocationForTableDropdown()
      .subscribe(result => {
        this.locations = result;
        debugger;
        const defaultLoc = this.locations.find(l => l.id === this.appSession.user.locationId);
        if (defaultLoc) {
          this.selectedLocations = [defaultLoc];
        }
      });
  }

  loadAccounts() {
    this.commonLookupService.getAllChartOfAccountForCombo()
      .subscribe(result => {
        this.accounts = result.items;
      });
  }

  loadFromRouteParams() {
    this.route.queryParams.subscribe(params => {
      if (params['startDate']) {
        this.dateRange[0] = new Date(params['startDate']);
      }
      if (params['endDate']) {
        this.dateRange[1] = new Date(params['endDate']);
      }
      if (params['locations']) {
        const ids = params['locations'].split('-').map((x: string) => Number(x));
        this.selectedLocations = this.locations.filter(l => ids.includes(l.id));
      }
      if (params['accountId']) {
        const acc = this.accounts.find(a => a.value === params['accountId']);
        if (acc) {
          this.selectedAccounts = [acc];
        }
      }
      setTimeout(() => {
          this.getDetails();
        }, 5000);  
      
    });
  }

  setDateRange(type: string) {
  const today = new Date();
  let start: Date, end: Date;

  switch (type) {
    case 'today':
      start = end = today;
      break;
    case '7days':
      start = new Date();
      start.setDate(today.getDate() - 6);
      end = today;
      break;
    case '30days':
      start = new Date();
      start.setDate(today.getDate() - 29);
      end = today;
      break;
    case 'thisMonth':
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;
    case 'lastMonth':
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = new Date(today.getFullYear(), today.getMonth(), 0);
      break;
    default:
      start = end = today;
  }

  this.dateRange = [start, end];
}


getDetails() {

  if (!this.dateRange || this.dateRange.length < 2) {
    return;
  }

  const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
  const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

  const locations = this.selectedLocations.length ? this.selectedLocations : this.locations;
  const accounts = this.selectedAccounts.length ? this.selectedAccounts : this.accounts;

  this.loading = true;

const input = new GetAccountJournalInput();
input.locationId = 0;
input.accountId = 0;
input.defaultLocationId = abp.session.userId;

input.startDate = startDate ? DateTime.fromISO(startDate) : undefined;
input.endDate = endDate ? DateTime.fromISO(endDate) : undefined;

input.locations = locations;
input.accounts = accounts;

input.transactionNo = null;
input.customerVendorId = 0;
input.journalNo = null;
input.isAuto = false;
input.defaultPeriod = 0;

input.sorting = '';
input.maxResultCount = 999;
input.skipCount = 0;

  this.accountJournalReportService
    .getGeneralLedger(input)
    .subscribe(result => {
      this.purchaseDetail = result;
      this.calculateTotals(result);
      this.loading = false;
    });
}


  calculateTotals(data: GeneralLedgerOutputDto[]) {
    this.debit = 0;
    this.credit = 0;

    data.forEach(x => {
      this.debit += x.debit;
      this.credit += x.credit;
    });

    this.closingBalance = Math.abs(this.debit - this.credit);
  }

exportExcel() {
  const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
  const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

  const locations = this.selectedLocations.length ? this.selectedLocations : this.locations;
  const accounts = this.selectedAccounts.length ? this.selectedAccounts : this.accounts;

  this.loading = true;

const input = new GetAccountJournalInput();
input.locationId = 0;
input.accountId = 0;
input.defaultLocationId = abp.session.userId;

input.startDate = startDate ? DateTime.fromISO(startDate) : undefined;
input.endDate = endDate ? DateTime.fromISO(endDate) : undefined;

input.locations = locations;
input.accounts = accounts;

input.transactionNo = null;
input.customerVendorId = 0;
input.journalNo = null;
input.isAuto = false;
input.defaultPeriod = 0;

input.sorting = '';
input.maxResultCount = 999;
input.skipCount = 0;

  this.accountJournalReportService.getGeneralLedger(input).subscribe(result => {
   /* abp.downloadTempFile(result);*/
    this.loading = false;
  });
}


}
